import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LogService {
    constructor(private http: HttpClient) {}

    private log(obj: Log) {
        if (!obj) {
            return;
        }
        switch (obj.logLevel) {
            case 'info':
                console.log(obj.error);
                break;
            case 'warn':
                console.warn(obj.error);
                break;
            case 'error':
                console.error(obj.error);
                break;
        }
        return this.http.post('/api/clientError/log', obj);
    }

    logInfo(error: any) {
        this.log({
            logLevel: 'info',
            error: error
        });
    }

    logWarn(error: any) {
        this.log({
            logLevel: 'warn',
            error: error
        });
    }

    logError(error: any) {
        this.log({
            logLevel: 'error',
            error: error
        });
    }
}

export interface Log {
    logLevel: LogLevel;
    error: any;
}

export declare type LogLevel = 'info' | 'warn' | 'error';
